import { Flame } from "lucide-react";

export function StreakBadge({ streak, visible = true, resetPulse = false }) {
  if (!visible) return null;
  return (
    <div
      className={`wmleye-streakbadge${resetPulse ? " wmleye-streakbadge--reset" : ""}`}
      data-testid="streak-badge"
      aria-label={`Streak ${streak}`}
      aria-live="polite"
    >
      <Flame size={16} aria-hidden />
      <span data-testid="streak-badge-value">Streak: {streak}</span>
    </div>
  );
}
